import type { TenantConfig } from '@/types/TenantConfig'

export const area15: TenantConfig = {
  logo: 'assets/area15/static/logo.png',
  themeMode: 'dark',
  themeOptions: {
    dialog: {
      headerBackground: '#281D1C',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      backgroundColor: '#2B2432',
    },
    mobileFooter: {
      backgroundColor: '#281D1C',
      cartButtonBorder: '2px solid white',
      cartButtonBackgroundColor: 'transparent',
    },
    backButton: {
      backgroundColor: '#D12229',
    },
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/area15/static/fonts2.css',
      // Serve Stripe style assets from a secure HTTPS protocol with `Access-Control-Allow-Origin: *`
      // to get it working on local insecure HTTP development domains, for debugging purposes only;
      // fontFaceStylesheet: 'https://area15.web.d1tix.com/assets/area15/static/fonts2.css',
    },
  },
  i18nOverrides: {
    en: {
      accountLinks: {
        loginLinkLongLabel: 'Login',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a date',
      },
    },
  },
}
